const ReferAFriendTrustIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12.8092L3.68714 15.5001L4.62553 14.5756C4.74345 14.4594 4.90233 14.3943 5.06786 14.3943H11.0177L15.308 10.0695C15.4985 9.87482 15.5435 9.58003 15.4177 9.33849C15.3724 9.25061 15.321 9.17789 15.2634 9.12033C15.1922 9.04919 15.0948 8.98445 14.9712 8.9261C14.7356 8.81505 14.4561 8.86038 14.2683 9.04083L11.2003 11.9644C11.0831 12.076 10.9274 12.1383 10.7655 12.1383H7.89542L7.28652 11.6355L9.85124 11.0147C10.0407 10.9688 10.1982 10.8379 10.278 10.6601L10.4667 10.2395C10.5793 9.98834 10.4671 9.69339 10.2159 9.58071C10.1517 9.55193 10.0822 9.53705 10.0119 9.53705H4.47029C4.30089 9.53705 4.13862 9.60524 4.02007 9.72626L1 12.8092Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4091 7.979L7.37699 5.11135C7.33738 5.07563 7.30361 5.0341 7.27472 4.98928C6.72171 4.09486 6.54371 3.37034 6.7407 2.81573C7.04298 1.96467 7.65779 1.5 8.57488 1.5C9.18627 1.5 9.79767 1.93858 10.4091 2.81573C10.9781 1.93858 11.5564 1.5 12.144 1.5C13.0254 1.5 13.5525 1.88509 13.9144 2.81573C14.2763 3.74637 14.0249 4.31516 13.5251 5.05131C13.192 5.54208 12.1533 6.51798 10.4091 7.979Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ReferAFriendTrustIcon;
